module.exports = __webpack_public_path__ + "static/media/Group15.16fa1b8f.png";